import Article from "./Article";
import css from "./Main.module.css";

const Main = () => {
	return (
		<main className={css.main}>
			<Article />
		</main>
	);
};

export default Main;
